import {
  Dialog,
  IconButton,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Fade,
  Backdrop,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{
        m: 0,
        padding: "8px 16px 0 16px",
        position: "relative",
        borderBottom: "1px solid #e0e0e0",
        backgroundColor: "#fafafa",
        borderRadius: "12px 12px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      {...other}
    >
      <Typography
        variant="h6"
        component="div"
        sx={{
          fontWeight: 600,
          fontSize: 18,
          color: "text.primary",
          pr: 4,
        }}
      >
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              color: "text.primary",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

function AppModalDialogBox({
  title,
  actionButton,
  actionButtonRenderer,
  titleRenderer,
  dialogContainerClass,
  children,
  isModalOpen,
  handleClose,
  size = "sm",
  handleScroll,
  maxHeight,
}: any) {
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isModalOpen}
      id="custom-modal-dialog"
      fullWidth
      maxWidth={size}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
      BackdropComponent={(props) => (
        <Backdrop
          {...props}
          invisible={false}
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            transition: "none !important",
            willChange: "auto",
            position: "fixed",
          }}
        />
      )}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow:
            "0 24px 38px rgba(0, 0, 0, 0.14), 0 9px 46px rgba(0, 0, 0, 0.12), 0 11px 15px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
          transition: "none !important",
          ...(maxHeight && { maxHeight }),
        },
      }}
      sx={{
        zIndex: 1000,
        "& .MuiDialog-container": {
          transition: "none !important",
        },
        "& .MuiBackdrop-root": {
          transition: "none !important",
          willChange: "auto",
        },
        "& .MuiDialog-paper": {
          transition: "none !important",
        },
      }}
    >
      <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
        {title}
      </CustomDialogTitle>
      <DialogContent
        onScroll={handleScroll}
        dividers
        sx={{
          p: 3,
          "&.MuiDialogContent-dividers": {
            borderTop: "1px solid #e0e0e0",
            borderBottom: "1px solid #e0e0e0",
          },
        }}
      >
        {children}
      </DialogContent>
      {actionButtonRenderer && (
        <DialogActions
          sx={{
            p: 2,
            backgroundColor: "#fafafa",
            borderRadius: "0 0 12px 12px",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          {actionButtonRenderer}
        </DialogActions>
      )}
    </Dialog>
  );
}

export { AppModalDialogBox };
